<template>

  <Modal v-if="visible" :value="true" @input="closeModal">
    <span slot="header">Excluir empresa</span>
    <div class="row text-align-center">
      <div class="col-md-12">
        <p>Deseja realmente excluir a empresa {{ company.name }}</p>
        <button class="btn btn-outline btn-md mr-2" @click="closeModal">Agora não</button>
        <button class="btn btn-outline-red btn-md" @click="$emit('deleteCompany', company)">Excluir</button>
      </div>
    </div>

    <Loading :load="load"/>
  </Modal>

</template>

<script>
  import Modal from '../../shares/specialTag/Modal'
  import Loading from '../../shares/Loading'

  export default {
    components: { Loading, Modal },
    computed: {
      visible() {
        return this.value
      }
    },
    data() {
      return {
        load: false
      }
    },
    methods: {

      closeModal() {
        this.$emit('input', false)
      }
    },
    name: 'ModalDeleteCompany',
    props: {
      company: { required: true, type: Object },
      value: { default: false, type: Boolean }
    }
  }
</script>

<style scoped>

</style>
